import { EventMarker, HiddenEventTypeEnum } from '@hotjar/webapp/features/Playbacks/types';
import type { ActionFilter } from '../types';

export const filterActions = (
  eventMarkers: EventMarker[],
  filters?: ActionFilter[],
): EventMarker[] => {
  if (!filters?.length) return eventMarkers;

  return eventMarkers.filter((marker) => {
    if (marker.type === HiddenEventTypeEnum.AUTOTAG_RECORDING) {
      return filters.includes(marker.name as ActionFilter);
    }

    return filters.includes(marker.type as string as ActionFilter);
  });
};
